import { endOfLocalDay, isPastDate, type PastSessionDeadlineInput } from "@/util/pastSessionDeadline";

/**
 * Disable “apply” CTAs when the session has an application_deadline and it is
 * past end-of-local-day (same rule as Program Details / pastSessionDeadline).
 * Missing deadline does not disable (avoids invalid parse inputs).
 */
export const isSessionApplyClosedByDeadline = (session: PastSessionDeadlineInput | undefined | null): boolean => {
  const deadline = session?.application_deadline;
  if (!deadline) {
    return false;
  }
  return isPastDate(endOfLocalDay(String(deadline)));
};
